import { useFlags } from "launchdarkly-react-client-sdk";

export const useSavedLessons = (): boolean => {
  const { savedLessons } = useFlags();

  return savedLessons;
};

export const useIntroHighlightedContent = (): boolean => {
  const { introHighlightedContentCard } = useFlags();

  return introHighlightedContentCard;
};

// LD flag `upgraded-path-quests-row-ux` — camelCased by the SDK.
// When ON: dashboard rows show a single preview row (cards-per-width) with a
// "Show all (N) →" button that links to dedicated /levels/:levelId and /quests
// pages, and levels are split into Current/Completed groups with completion
// checkmarks. When OFF: original horizontal-scroll rows, flat level list.
export const useUpgradedPathQuestsRowUx = (): boolean => {
  const { upgradedPathQuestsRowUx } = useFlags();

  return upgradedPathQuestsRowUx;
};
